import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, message, Spin } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import ComList from '../ComList';
import SelectResumeRole from './SelectResumeRole';
import { saveParams, saveQueryParams } from '../../../actions/PersonalActions';

const monthFormat = "YYYY-MM";

class UpdateClinicalTrialExp extends Component {
    state = {
        params: {},
        loading: false,
        isTruePm:false,
    }

    componentWillReceiveProps(nextProps) {
        if (!this.props.filterVisible && nextProps.filterVisible) {
            this.loadAreaList();
            this.queryWorkPosition();
            this.queryVitaeList('CLINICAL_EXPERIENCE');
            this.queryInvestigation('');
            this.queryStageIds();
        }
    }

    hide = () => {
        this.setState({
            diseaseOptions: [],
        }, () => {
            this.props.showFilter(false);
        });
    }
    queryCrcUsedToBePm =()=>{
        const { userId } = this.props;
        const { params:{vitaeWorkExperienceStartTime,vitaeWorkExperienceEndTime} } = this.state;
        const options = {
            method: 'POST',
            url: API_URL.personal.queryCrcUsedToBePm,
            data: {
                userId,
                vitaeWorkExperienceStartTime,
                vitaeWorkExperienceEndTime
            },
            dataType: 'json',
            doneResult: res => {
                this.setState({isTruePm:res.result},this.isTruePmFun);
            }
        };
        $.sendRequest(options);
    }
    queryWorkPosition = () => {
        const { userId, isChinese } = this.props;
        const options = {
            method: 'POST',
            url: API_URL.personal.queryVitaePositionByUserId,
            data: {
                userId,
                typeName: isChinese ? 'CHINESE' : 'ENGLISH',
            },
            dataType: 'json',
            doneResult: res => {
                const { data = [] } = res;
                const options = data.map(item => {
                    const { positionName, englishName } = item;
                    return {
                        zh: positionName,
                        en: englishName,
                        value: isChinese ? positionName : englishName,
                    };
                });
                const optionsFilter = options.filter(i => isChinese ? i.zh : i.en);
                this.setState({ postionOptions: optionsFilter });
            }
        };
        $.sendRequest(options);
    }

    queryVitaeList = (typeName) => {
        const options = {
            method: 'POST',
            url: API_URL.personal.queryVitaeList,
            data: {typeName},
            dataType: 'json',
            doneResult: res => {
                const { vitaeList = [] } = res;
                const options = vitaeList.map(item => {
                    const { vitaeDictId, chName, enName, childList } = item;
                    return {
                        zh: chName,
                        en: enName,
                        value: vitaeDictId,
                        child: childList,
                    };
                });
                this.setState({ roleOptions: options });
            }
        };
        $.sendRequest(options);
    }

    loadAreaList = () => {
        const { isChinese } = this.props;
        const options = {
            method: 'POST',
            url: API_URL.common.queryAllInvestigationArea,
            data: {},
            dataType: 'json',
            doneResult: res => {
                const areaOptions = (res.data || []).map(item => {
                    const { englishName, investigationAreaId, investigationAreaName } = item;
                    return {
                        zh: investigationAreaName,
                        en: englishName,
                        value: investigationAreaId,
                    };
                });
                const optionsFilter = areaOptions.filter(i => isChinese ? i.zh : i.en);
                this.setState({ areaOptions: optionsFilter });
            }
        };
        $.sendRequest(options);
    }

    loadDiseaseList = (investigationAreaId) => {
        const options = {
            method: 'POST',
            url: API_URL.common.queryAllDisease,
            data: { investigationAreaId },
            dataType: 'json',
            doneResult: res => {
                const diseaseOptions = (res.data || []).map(item => {
                    const { diseaseId, diseaseName, englishName } = item;
                    return {
                        value: diseaseId,
                        zh: diseaseName,
                        en: englishName,
                    };
                });
                this.setState({ diseaseOptions });
            }
        };
        $.sendRequest(options);
    }

    queryInvestigation = (keyword) => {
        const { userId } = this.props;
        const options = {
            method: 'POST',
            url: API_URL.personal.queryInvByUserId,
            data: {
                userId,
                keyword,
            },
            dataType: 'json',
            doneResult: res => {
                const { data = [] } = res;
                const options = data.map(item => {
                    const { investigationName=null, investigationId } = item;
                    return {
                        zh: investigationName,
                        en: investigationName,
                        value: investigationId,
                    };
                });
                this.setState({ investigationOptions: options });
            }
        };
        $.sendRequest(options);
    }

    queryStageIds = () =>{
        const options = {
            method: 'POST',
            url: API_URL.common.typeConfigureList,
            data: {},
            dataType: 'json',
            doneResult: res => {
                const {stageList = [] } =res
                const options = stageList.map(item => {
                    const { typeValue=null, typeConfigureId } = item;
                    return {
                        zh: typeValue,
                        en: typeValue,
                        value: typeConfigureId,
                    };
                });
                this.setState({ stageIdOptions: options });
            }
        }
        $.sendRequest(options)
    }

    getRenderList = () => {
        const { isChinese } = this.props;
        const {
            postionOptions = [],
            areaOptions = [],
            diseaseOptions = [],
            roleOptions = [],
            investigationOptions = [],
            stageIdOptions = [],
        } = this.state;
        postionOptions.forEach(i => i.name = isChinese ? i.zh : i.en);
        areaOptions.forEach(i => i.name = isChinese ? i.zh : i.en);
        diseaseOptions.forEach(i => i.name = isChinese ? i.zh : i.en);
        roleOptions.forEach(i => i.name = isChinese ? i.zh : i.en);
        investigationOptions.forEach(i => i.name = isChinese ? i.zh : i.en);
        stageIdOptions.forEach(i => i.name = isChinese ? i.zh : i.en);
        const renderList = [{
            zh: <p style={{ fontWeight: 'bold' }}>工作经历筛选:</p>,
            en: <p style={{ fontWeight: 'bold' }}>Work History:</p>,
            colon: false,
            attr: {
                left: { width: '35%', textAlign: 'left' },
                right: { width: '65%' },
            },
        }, {
            zh: '开始时间',
            en: 'Start Time',
            key: 'vitaeWorkExperienceStartTime',
            option: {
                type: 'monthPicker',
                allowClear: true,
                format: monthFormat,
                style: { width: 220 },
                placeholder: isChinese ? '请选择' : 'Please select ',
            },
            attr: {
                left: { width: '35%' },
                right: { width: '65%' },
            },
        }, {
            zh: '结束时间',
            en: 'End Time',
            key: 'vitaeWorkExperienceEndTime',
            option: {
                type: 'monthPicker',
                allowClear: true,
                format: monthFormat,
                style: { width: 220 },
                placeholder: isChinese ? '请选择' : 'Please select ',
            },
            attr: {
                left: { width: '35%' },
                right: { width: '65%' },
            },
        }, {
            zh: '职务',
            en: 'Post',
            key: 'positionName',
            option: {
                type: 'select',
                allowClear: false,
                list: postionOptions,
                style: { width: 220 },
                placeholder: isChinese ? '请选择' : 'Please select ',
            },
            attr: {
                left: { width: '35%' },
                right: { width: '65%' },
            },
        }, {
            zh: <p style={{ fontWeight: 'bold' }}>临床试验经验筛选:</p>,
            en: <p style={{ fontWeight: 'bold' }}>Clinical Trial Expericence:</p>,
            colon: false,
            attr: {
                left: { width: '50%', textAlign: 'left' },
                right: { width: '65%' },
            },
        }, {
            zh: '开始时间',
            en: 'Start Time',
            key: 'vitaeClinicalExperienceStartTime',
            option: {
                type: 'monthPicker',
                allowClear: true,
                format: monthFormat,
                style: { width: 220 },
                placeholder: isChinese ? '请选择' : 'Please select ',
            },
            attr: {
                left: { width: '35%' },
                right: { width: '65%' },
            },
        }, {
            zh: '结束时间',
            en: 'End Time',
            key: 'vitaeClinicalExperienceEndTime',
            option: {
                type: 'monthPicker',
                allowClear: true,
                format: monthFormat,
                style: { width: 220 },
                placeholder: isChinese ? '请选择' : 'Please select ',
            },
            attr: {
                left: { width: '35%' },
                right: { width: '65%' },
            },
        }, {
            zh: '项目领域',
            en: 'Therapeutic Area',
            key: 'investigationAreaId',
            option: {
                type: 'select',
                allowClear: false,
                list: areaOptions,
                style: { width: 220 },
                placeholder: isChinese ? '请选择' : 'Please select ',
            },
            attr: {
                left: { width: '35%' },
                right: { width: '65%' },
            },
        }, {
            zh: '疾病',
            en: 'Indications',
            key: 'diseaseId',
            option: {
                type: 'select',
                allowClear: false,
                list: diseaseOptions,
                style: { width: 220 },
                placeholder: isChinese ? '请选择' : 'Please select ',
                onFocus: () => this.handleFocus('项目领域', 'investigationAreaId'),
            },
            attr: {
                left: { width: '35%' },
                right: { width: '65%' },
            },
        }, {
            zh: '项目角色',
            en: 'Role',
            key: 'clinicalRoleId',
            option: {
                type: 'select',
                allowClear: false,
                list: roleOptions,
                style: { width: 220 },
                placeholder: isChinese ? '请选择' : 'Please select ',
            },
            attr: {
                left: { width: '35%' },
                right: { width: '65%' },
            },
        }, {
            zh: '项目简称',
            en: 'Project abbreviation',
            key: 'investigationId',
            option: {
                mode: 'search_multiple',
                type: 'select',
                allowClear: false,
                list: investigationOptions,
                style: { width: 220 },
                placeholder: isChinese ? '请选择(可多选)' : 'Please select(Multiple choice) ',
            },
            attr: {
                left: { width: '35%' },
                right: { width: '65%' },
            },
        },{
            zh: '项目阶段',
            en: 'Project phase',
            key: 'stageId',
            option: {
                mode: 'search_multiple',
                type: 'select',
                allowClear: false,
                list: stageIdOptions,
                style: { width: 220 },
                placeholder: isChinese ? '请选择(可多选)' : 'Please select(Multiple choice) ',
            },
            attr: {
                left: { width: '35%' },
                right: { width: '65%' },
            },
        }];
        const setName = (item) => {
            if (isChinese) {
                item.name = item.zh;
            } else {
                item.name = item.en;
            }
        };
        const loopArr = (arr) => {
            if (Array.isArray(arr)) {
                arr.forEach(item => loopArr(item));
            } else {
                setName(arr);
            }
        };
        loopArr(renderList);
        this.renderList = renderList;;
    }

    checkValue = param => {
        const { params } = this.state;
        const { name, key, require, option, warning, display } = param;
        const { placeholder } = option || {};
        
        let noError = true;
        if (require) {
            if (!params[key] && !display) {
                message.warning(`${placeholder}${warning || name || ''}`);
                noError = false;
            } else {
                if (display) {
                    const { symbol, key, value = null } = display;
                    if (symbol === 'eq') {
                        if (value) {
                            const list = this.renderList || [];
                            const tar = list.find(i => i.key === key);
                            const arr = tar.option.list || [];
                            const o = arr.find(a => a.value == params[key]);
                            if (o && o.name === value && !params[param.key]) {
                                message.warning(`${placeholder}${warning || name || ''}`);
                                noError = false;
                            }
                        } else {
                            if (params[key] && !params[param.key]) {
                                message.warning(`${placeholder}${warning || name || ''}`);
                                noError = false;
                            }
                        }
                    }
                }
            }
        }
        return noError;
    }
    
    isTruePmFun = () =>{
        const { isTruePm } = this.state;
        if(isTruePm){
            this.selectResumeRef.show();
        }else{
            this.submit()
        }
    }
    submit = () => {
        const { params } = this.state;
        const { type, isChinese } = this.props;
        this.getRenderList();
        const renderList = this.renderList || [];
        const hasError = renderList.every(item => {
            if (Array.isArray(item)) {
                return item.every(i => this.checkValue(i));
            } else {
                return this.checkValue(item);
            }
        });
        if (!hasError) {
            return;
        }

        const { investigationId, stageId , ...rest } = params;
        const investigationIds = (investigationId || []).map(i => i.key).join(',');
        const stageIds = (stageId || []).map(i => i.key).join(',');
        this.props.saveParams({ isChinese });
        this.props.saveQueryParams({
            ...rest,
            investigationId: investigationIds,
            stageIds 
        });
        location.href = `./#/${type}/generateCurriculumVitae`;
    }

    handleSearch = (value) => {
        if (this.timer) {
            clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => {
            this.queryInvestigation(value);
        }, 300);
    }

    handleChange = (value, key) => {
        const { params } = this.state;
        params[key] = value;

        if (key === 'investigationAreaId') {
            params.diseaseId = undefined;
            this.loadDiseaseList(value);
        }
        this.setState({ params });
    }

    handleFocus = (name, key) => {
        const { params } = this.state;
        if (!params[key]) {
            message.warning(`请先选择${name}`);
        }
    }

    render() {
        const { loading, params } = this.state;
        const { filterVisible } = this.props;
        this.getRenderList();
        const list = this.renderList || [];
        return (
            <Modal
                title="简历筛选"
                visible={filterVisible}
                onCancel={this.hide}
                onOk={this.queryCrcUsedToBePm}
                className="create-modal EditPersonModal"
                confirmLoading={loading}
                maskClosable={false}
                width="500px"
                bodyStyle={{maxHeight:600}}
            >
                <Spin spinning={loading}>
                    <div className="modal-content" style={{ padding: '0 20px' }}>
                        <div style={{ lineHeight: '24px', fontSize: '13px', color: '#ffa500' }}>(不填写筛选条件，即表示选择所有工作经历、临床试验经验)</div>
                        <ComList
                            list={list}
                            params={params}
                            onFocus={(name, key) => this.handleFocus(name, key)}
                            onChange={(value, key) => this.handleChange(value, key)}
                            onSearch={(value, key) => this.handleSearch(value, key)}
                        />
                    </div>
                </Spin>
                <SelectResumeRole  ref={el => this.selectResumeRef = el} submit={this.submit}/>
            </Modal>
        )
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        saveParams: (params) => dispatch(saveParams(params)),
        saveQueryParams: (params) => dispatch(saveQueryParams(params))
    }
}

export default connect(null, mapDispatchToProps)(UpdateClinicalTrialExp);


// WEBPACK FOOTER //
// ./src/components/common/curriculumVitae/CurriculumVitaeFilter.js